// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"nP","tag":"nQ","isRental":"nR","title":"nS","title2":"nT","description":"nU","cta":"nV","ratingLabel":"nW","ratingLabelSmallScreen":"nX","iconInHotspotVideo":"nY"};